import { net_common } from "@/api/http";
export const API_STDSCM01C01 = (...params) =>
  net_common.post("/api/STDSCM01C01", ...params);
